export default __webpack_public_path__ + "static/media/sp-cover.77109a88.png";